import { 
  EXPENSE_LIST_SUCCESS, 
  EXPENSE_PAY_BATCH_LIST_SUCCESS, 
} from "../constants";

const initialState = {
  list: [],
  batchList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case EXPENSE_LIST_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  case EXPENSE_PAY_BATCH_LIST_SUCCESS:
    return {
      ...state,
      batchList: action.payload
    };
  default:
    return state;
  }
}